<template>
  <div v-if="show" :class="{loader: true, 'full-page': fixed, 'use-background': initialLoad}">
    <div class="loader-wrapper">
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div v-if="initialLoad" class="loader-text">Initializing IRIS, please wait.</div>
      <div v-else class="loader-text">Please wait a moment.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    fixed: Boolean,
    show: Boolean,
    initialLoad: Boolean
  }
}
</script>

<style scoped>
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background-color: rgba(255,255,255,0.4);
}
.loader.full-page {
  position: fixed;
  z-index: 999999999;
}
.loader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.loader-text {
  margin-top: 10px;
  color: #333333;
  font-size: 16px;
}
.lds-spinner {
  color: #333333;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #333333;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.use-background {
  background-image: url("../../assets/images/backgrounds/bg-repeat.svg");
  background-size: 150px 150px;
  background-repeat: repeat;
}
</style>
